import { Clone, useGLTF } from "@react-three/drei";
import { useEffect } from "react";
import Tile from "./Tile.jsx";

export default function CityBlock(props) {
  const model = useGLTF(props.block.path);

  useEffect(() => {
    console.log("Model loaded!");
  }, []);

  return (
    <group {...props}>
      <Clone object={model.scene} scale={0.33} />
      <Tile scale={0.33} tileColor={props.block.tileColor} />
    </group>
  );
}
